                                                                                                                                                                                                                                                                                
     

 


 




  
// GLOBAL *****************************************                         


// redirects ***             
var thisGlobalRedirectPath = window.location.pathname;  
if (thisGlobalRedirectPath === "/cart" || thisGlobalRedirectPath === "/cart/") { window.location.href = "/?opencart=true"; } 
if (thisGlobalRedirectPath.includes('/products') || thisGlobalRedirectPath.includes('/collections') || thisGlobalRedirectPath.includes('/search')) { window.location.href = "/"; }


   









// PRELOAD *******************************                                                                                                                             
                                                
      
// set dims on resize + on load *** 
$(window).on("resize", function() { nPreloadSetDims(); }).resize();


// hide preload on load *** 
setTimeout(function() { nPreloadHide(); }, 1000);  


// handle back/forward navigation bug ***
window.addEventListener("pageshow", function(e) {
    let nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    let cameFromHistory = e.persisted || (nav && nav.type === "back_forward"); 
    if (cameFromHistory) { setTimeout(function() { nPreloadHide(); }, 250); }
}); 


// hide pload helper ***    
function nPreloadHide() { 
    $("#PreloadCircle, #PreloadOverlay").addClass("hide");
    setTimeout(function() {
        $("#PreloadCircle, #PreloadOverlay").css({"display":"none"});  
    }, 700);
}


// set pload dims helper *** 
function nPreloadSetDims() {
    let nA = $(window).height() / 2;
    let nB = $(window).width() / 2;
    let nRadius = Math.sqrt((nA * nA) + (nB * nB));
    let nDiameter = 2 * nRadius; 
    $("#PreloadCircle").css({
        width: nDiameter,
        height: nDiameter,
        marginTop: -nRadius,
        marginLeft: -nRadius
    });
}











        
// NAVIGATION *****************************************       
   
       
// ham init ***
var navDone = true;


// open nav menu ***
$("#Hamburger").click(function() {
    if (navDone) {
        navDoneUtil(false);
        navOpen(); 
    }
});


// close nav menu ***
$("#HamClose").click(function() {
    if (navDone) {
        navDoneUtil(false);
        navClose();
    }
});


// scroll to ***
$(".smoothscroll, .mobilescroll").click(function(e) {
    e.preventDefault(); 
    if (navDone) {
        let scrollTo = $(this).attr("data-scrollto");
        $("html, body").animate({ scrollTop: $("#" + scrollTo).offset().top - 140 }, 700, "easeInExpo");
        if ($(this).hasClass("mobilescroll")) { 
            navDoneUtil(true);  
        }
    }
}); 


// done util ***
function navDoneUtil(closeNav) {
    if (closeNav) { navClose(); }
    navDone = false;
    setTimeout(function() { navDone = true; }, 700);
}  


// ham open ***
function navOpen() {
    $("#Navigation, #NavigationExtraBtns").addClass("hidenavddopen");
    $("#DropDownMenu").addClass("display");
    $("#DropDownMenuOverlay").addClass("active");
}


// ham close ***
function navClose() {
    $("#Navigation, #NavigationExtraBtns").removeClass("hidenavddopen");
    $("#DropDownMenu").removeClass("display");
    $("#DropDownMenuOverlay").removeClass("active");
}


// add active class to nav on scroll *** 
$(window).on("scroll", function() {
    const navScrollCurrentPath = window.location.pathname;
    if (navScrollCurrentPath === '/' || navScrollCurrentPath === '/pages/about' || navScrollCurrentPath === '/pages/camps' || navScrollCurrentPath === '/pages/schedule') { 
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 100) {
            $("#DekstopNavigation").addClass("active");
        } 
        else {
            $("#DekstopNavigation").removeClass("active");
        }
    } 
    else {
        $("#DekstopNavigation").addClass("active");   
    }
}).scroll();












// CART FUNCTIONALITY *****************************************
$(window).on("load", function () {                        




    // init ***
    var doneUtil = [{ done: true }, { done: true }, { done: true }, { done: true }];
    var addToCart = false;
    var firstAddToCart = true;
    var totalCartItems = 0;
    var totalPrice = 0; 
    var setTotalCartItemsAgain = true;
    var CART_FETCH_MAX_RETRIES = 8;




    // set total cart items ***
    setTotalCartItems();




    // open cart press ***
    $("#NavCartButton").click(function () {
        if (doneUtil[0].done) {
            doneUtilFunc(0, 1000);
            if (setTotalCartItemsAgain) {
                setTotalCartItemsAgain = false;
                setTotalCartItems();
            }
            let openCartDelay = 250; 
            if (!addToCart && totalCartItems !== 0) {
                fetchCartData({
                    delay: 50,
                    openAfterLoad: false
                });
                openCartDelay = 400;
            }  
            openCartSuccess(openCartDelay);
        }
    });




    // open cart success ***
    function openCartSuccess(delayTimer) {
        setTimeout(function () {
            $("#CartSection").css({ "display": "block" }); 
            setTimeout(function () {
                addToCart = false;
                if (!firstAddToCart) { firstAddToCart = true; }
                ddsCartIsEmpty(totalCartItems === 0);
                $("#CartSection").addClass("active");
                $("#CartSection #Cart").addClass("active"); 
            }, 50);
        }, delayTimer);
    }




    // close cart ***
    $("#CartClose").click(function () {
        if (doneUtil[0].done) {
            doneUtilFunc(0, 1000);
            $("#CartSection #Cart").removeClass("active");
            setTimeout(function () { 
                $("#CartSection").removeClass("active"); 
                setTimeout(function () {
                    $("#CartSection").css({ "display": "none" });  
                }, 550); 
            }, 300);
        }
    });




    // add to cart buttons ***
    $(document).on("click", "#BuyClubTeamSeason", function () { 
        if (doneUtil[1].done && firstAddToCart) {
            doneUtilFunc(1, 1000);

            // loading animation 
            let $btn = $(this);
            if ($btn.find(".product-btn-loadingoverlay").length) { return; }
            $btn.append("<div class='product-btn-loadingoverlay'><img src='//flyhighball.com/cdn/shop/files/loading.gif?v=8091455524972651826'></div>");
            let $btnOver = $btn.find(".product-btn-loadingoverlay");
            setTimeout(function() {
                $btnOver.addClass("active"); 
                setTimeout(function () {
                    $btnOver.removeClass("active");
                    setTimeout(function() {
                        $btnOver.remove();
                    }, 350);
                }, 2000); 
            }, 50);
    
            // set cart item again
            if (setTotalCartItemsAgain) {
                setTotalCartItemsAgain = false;
                setTotalCartItems();
            }

            // add to cart flag 
            addToCart = true;

            // prepare cart item object  
            let cartItems = [];
            let gearIncluded = $(this).attr("data-gear-included") === "true";
      
            // always add the base season item
            cartItems.push({
                quantity: 1,
                id: 44323277504611,
                selling_plan: 16887316579
            });

            // only add gear items if YES is selected
            if (gearIncluded) {
                cartItems.push({
                    quantity: 1,
                    id: 44323060514915
                });
                cartItems.push({
                    quantity: 1,
                    id: 44323038691427
                }); 
                cartItems.push({
                    quantity: 1,
                    id: 44322966601827
                });
            }
 
            // add to cart handler
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                contentType: "application/json",    
                data: JSON.stringify({ items: cartItems }),      
                dataType: "json",
                success: function () {
                    fetchCartData({
                        delay: 250,
                        addedQty: cartItems.length, 
                        openAfterLoad: true
                    });
                },
                error: function (xhr) {
                    console.log("Cart error:", xhr.responseText);
                    addToCart = false;
                    firstAddToCart = true;
                    setTotalCartItems();
                    fetchCartData({ delay: 0, openAfterLoad: false });
                }
            });

        }
    });




    // fetch cart data *** 
    function fetchCartData(options) {

        // init 
        options = options || {};
        let timeoutDelay = options.delay || 0;
        let nQty = Number(options.addedQty || 0); 
        let retries = Number(options.retries || 0);
        let openAfterLoad = options.openAfterLoad === true;

        // operations 
        setTimeout(function () { 
            fetch(window.Shopify.routes.root + "cart.js")
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    if (addToCart && firstAddToCart && nQty > 0) {
                        firstAddToCart = false;
                        totalCartItems += nQty;
                    }
                    if ((data.item_count === 0 || data.item_count < totalCartItems) && retries < CART_FETCH_MAX_RETRIES) {
                        fetchCartData({
                            delay: 250,
                            addedQty: 0, 
                            retries: retries + 1,
                            openAfterLoad: openAfterLoad
                        });
                        return;
                    }
                    useCartData(data);
                    if (openAfterLoad && addToCart) {
                        $("#NavCartButton").click();
                    }
                })
                .catch(function () {  
                    setTotalCartItems();
                });
        }, timeoutDelay);

    }




    // display fetched cart data ***
    function useCartData(data) {

        // clear cart 
        $("#Cart #CartItems").html("");

        // set price & cart items  
        totalPrice = 0;
        totalCartItems = data.item_count || 0;

        // render cart items
        for (let i = 0; i < data.items.length; i++) {
            let item = data.items[i];
            let realPrice = item.price / 100;
            let priceDisplay = "$" + realPrice.toFixed(2);
            if (item.quantity > 1) {
                priceDisplay =
                    "$" + (realPrice * item.quantity).toFixed(2) +
                    " <span class='unit-price'>($" + realPrice.toFixed(2) + " /ea)</span>";
            }
            $("#Cart #CartItems").append(
                "<div class='cartitem " + item.id + "'>" +
                    "<img class='citemcol img' src='" + item.image + "'>" +
                    "<div class='citemcol header'>" +
                        "<h2>" + item.title + "</h2>" +
                        "<p>" + priceDisplay + "</p>" +
                    "</div>" +
                    "<div class='citemcol adjust'>" +
                        "<h5 data-adjustid='" + item.id + "' data-adjustprice='" + realPrice + "' data-adjustkey='" + item.key + "'>" +
                            " <span class='minus mp'>-</span> <span class='qty'>" + item.quantity + "</span> <span class='plus mp'>+</span>" +
                        " </h5>" +
                        "<a class='removecartitem' data-removalid='" + item.id + "' data-removalprice='" + realPrice + "' data-removalkey='" + item.key + "'>REMOVE</a>" +
                    "</div>" +
                    "<div class='citemclearfloat'></div>" +
                "</div>"
            );
            totalPrice += realPrice * item.quantity;
        }

        // handle other operations    
        $("#CartFooter a span.total").text("$" + totalPrice.toFixed(2)); 
        ddsCartIsEmpty(totalCartItems === 0);

    } 




    // adjust cart qty ***
    $(document).on("click", ".citemcol.adjust h5 span.mp", function () {
        if (doneUtil[2].done) {
            doneUtilFunc(2, 300);
            let nThis = $(this);
            let type = nThis.attr("class");
            let $row = nThis.parent();
            let thisQty = Number($row.find(".qty").text());
            let thisKey = $row.attr("data-adjustkey");
            if (type === "minus mp" && thisQty > 1) {
                thisQty--;
            } 
            else if (type === "plus mp") {
                thisQty++;
            } 
            else {
                return;
            } 
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: {
                    id: thisKey,
                    quantity: thisQty
                },
                dataType: "json",
                success: function (data) {
                    nThis.parent().find(".qty").text(thisQty); 
                    useCartData(data);
                },
                error: function () {   
                    fetchCartData({ delay: 0, openAfterLoad: false });
                }
            });
        }
    }); 




    // remove cart item ***
    $(document).on("click", ".citemcol.adjust .removecartitem", function () {
        if (doneUtil[3].done) {
            doneUtilFunc(3, 1000);
            let nThis = $(this);
            let thisRemovalKey = nThis.attr("data-removalkey"); 
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: {
                    id: thisRemovalKey,
                    quantity: 0
                },
                dataType: "json",
                success: function (data) {
                    useCartData(data);   
                },
                error: function () {
                    fetchCartData({ delay: 0, openAfterLoad: false });
                }
            });
        }
    });   




    // set total cart items ***
    function setTotalCartItems() {
        fetch(window.Shopify.routes.root + "cart.js")
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                totalCartItems = data.item_count || 0;
            })
            .catch(function () {
                totalCartItems = 0; 
            });
    }




    // cart empty ***
    function ddsCartIsEmpty(type) {
        if (type === true) {
            $("#CartHasItems").css({ "display": "none" });
            $("#CartEmpty").css({ "display": "block" });
        } 
        else {
            $("#CartHasItems").css({ "display": "block" });
            $("#CartEmpty").css({ "display": "none" });
        }
    }




    // close on document press ***
    $(document).click(function (e) {
        if ($("#CartSection").hasClass("active")) {
            if (!$(e.target).closest("#Cart").length && doneUtil[0].done) {
                $("#CartClose").click();
            }
        }
    });




    // done util ***
    function doneUtilFunc(pos, delay) {
        doneUtil[pos].done = false;
        setTimeout(function () {
            doneUtil[pos].done = true;
        }, delay);
    }




});












/*            
 * Title: Typewriter JS
 * Description: A native javascript plugin that can be used to create an elegent automatic typewriter animation effect on websites.
 * Author: Tameem Safi
 * Website: https://safi.me.uk
 * Version: 1.0.0
 */

(function(){(function(){for(var a=0,c=["ms","moz","webkit","o"],b=0;b<c.length&&!window.requestAnimationFrame;++b)window.requestAnimationFrame=window[c[b]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[b]+"CancelAnimationFrame"]||window[c[b]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(c,b){var f=(new Date).getTime(),d=Math.max(0,16-(f-a)),e=window.setTimeout(function(){c(f+d)},d);a=f+d;return e});window.cancelAnimationFrame||(window.cancelAnimationFrame=
function(a){clearTimeout(a)})})();window.Typewriter=function(a,c){this._settings={cursorAnimationPaused:!1,opacityIncreasing:!1,currentOpacity:1,delayedQue:[],delayItemsCount:0,eventQue:[],calledEvents:[],eventRunning:!1,timeout:!1,delayExecution:!1,fps:.06,typingFrameCount:0,stringToTypeHTMLArray:[],currentTypedCharacters:[],typing:!1,usedIDs:[],charAmountToDelete:!1,userOptions:{},eventLoopRerun:0};if(!a)return console.error("Please choose an DOM element so that type writer can display itself.");
if("object"!==typeof c)return console.error("Typewriter only accepts the options as an object.");this._settings.userOptions=c;this.default_options={strings:!1,cursorClassName:"typewriter-cursor",cursor:"|",animateCursor:!0,blinkSpeed:50,typingSpeed:"natural",deleteSpeed:"natural",charSpanClassName:"typewriter-char",wrapperClassName:"typewriter-wrapper",loop:!1,autoStart:!1,devMode:!1};this.options=this._setupOptions(c);this.el=a;this._setupTypwriterWrapper();this._startCursorAnimation();!0===this.options.autoStart&&
this.options.strings&&this.typeOutAllStrings()};var b=window.Typewriter.prototype;b.stop=function(){this._addToEventQue(this._stopEventLoop);return this};b.start=function(){this._startEventLoop();return this};b.rerun=function(){this._addToEventQue(this._rerunCalledEvents);return this};b.typeString=function(a){if(!a||"string"!=typeof a)return console.error("Please enter a string as the paramater.");a=this._getCharacters(a);this._addToEventQue([this._typeCharacters,[a]]);return this};b.deleteAll=function(){this._addToEventQue([this._deleteChars,
["all"]]);return this};b.deleteChars=function(a){this._addToEventQue([this._deleteChars,[a]]);return this};b.pauseFor=function(a){this._addToEventQue([this._pauseFor,[a]]);return this};b.typeOutAllStrings=function(){var a=this._getStringsAsCharsArray();if(1===a.length)this._typeCharacters(a[0]);else for(var c=0,b=a.length;c<b;c++)this._addToEventQue([this._typeCharacters,[a[c]]]),this.pauseFor(this._randomInteger(1500,2500)),this.deleteAll(),this.pauseFor(this._randomInteger(1500,2500));return this};
b.changeSettings=function(a){if(!a&&"object"!==typeof a)return console.error("Typewriter will only accept an object as the settings.");this._addToEventQue([this._changeSettings,[JSON.stringify(a)]]);return this};b.changeBlinkSpeed=function(a){if(!a&&"number"!==typeof a)return console.error("Please enter a number for the new blink speed.");this.changeSettings({blinkSpeed:a});return this};b.changeTypingSpeed=function(a){if(!a&&"number"!==typeof a)return console.error("Please enter a number for the new typing speed.");
this.changeSettings({typingSpeed:a});return this};b.changeDeleteSpeed=function(a){if(!a&&"number"!==typeof a)return console.error("Please enter a number for the new delete speed.");this.changeSettings({changeDeleteSpeed:a});return this};b._rerunCalledEvents=function(){0<this._settings.currentTypedCharacters.length?(this.deleteAll(),this._resetEventLoop("rerunCalledEvents")):(this._settings.eventQue=this._settings.calledEvents,this._settings.calledEvents=[],this.options=this._setupOptions(this._settings.userOptions),
this._settings.usedIDs=[],this.charAmountToDelete=!1,this._startEventLoop())};b._deleteChars=function(a){a&&(this._settings.charAmountToDelete=a);this._deletingCharIdsAnimation=window.requestAnimationFrame(this._deletingCharAnimationFrame.bind(this));return this};b._pauseFor=function(a){var c=this;c._settings.eventRunning=!0;setTimeout(function(){c._resetEventLoop("pauseFor")},a)};b._changeSettings=function(a){this.options=this._setupOptions(JSON.parse(a[0]));this._resetEventLoop("changeSettings");
this.options.devMode&&console.log("New settings",this.options)};b._deletingCharAnimationFrame=function(){var a=this,c=this.options.deleteSpeed,b=a.options.wrapperClassName,d=a._settings.currentTypedCharacters,e=a._settings.charAmountToDelete;if(!a._settings.charAmountToDelete||0===a._settings.charAmountToDelete||0===d)return a._resetEventLoop("deletingCharAnimationFrame"),!0;"natural"==c&&(c=a._randomInteger(50,150));"all"==e&&(e=d.length,a._settings.charAmountToDelete=e);setTimeout(function(){if(a._settings.charAmountToDelete){var c=
d.length-1,f=d[c];a._settings.currentTypedCharacters.splice(c,1);if(c=document.getElementById(f))a.el.querySelector("."+b).removeChild(c),a._settings.charAmountToDelete=e-1,a.options.devMode&&console.log("Deleted char with ID",f)}a._deletingCharIdsAnimation=window.requestAnimationFrame(a._deletingCharAnimationFrame.bind(a))},c)};b._setupOptions=function(a){var c={},b;for(b in this.default_options)c[b]=this.default_options[b];if(this._settings.userOptions)for(b in this._settings.userOptions)c[b]=this._settings.userOptions[b];
for(b in a)c[b]=a[b];return c};b._addToEventQue=function(a){this._settings.eventQue.push(a);0<this._settings.eventQue.length&&!this._settings.eventRunning&&this.options.autoStart&&this._startEventLoop()};b._startEventLoop=function(){this.options.devMode&&console.log("Event loop started.");if(!this._settings.eventRunning){if(0<this._settings.eventQue.length){this.eventLoopRerun=0;var a=this._settings.eventQue[0];"function"==typeof a?(this._settings.eventRunning=!0,this._settings.calledEvents.push(a),
this._settings.eventQue.splice(0,1),a.call(this),this.options.devMode&&console.log("Event started.")):a instanceof Array&&"function"==typeof a[0]&&a[1]instanceof Array&&(this._settings.eventRunning=!0,this._settings.calledEvents.push(a),this._settings.eventQue.splice(0,1),a[0].call(this,a[1]),this.options.devMode&&console.log("Event started."))}this._eventQueAnimation=window.requestAnimationFrame(this._startEventLoop.bind(this))}if(!this._settings.eventRunning&&0>=this._settings.eventQue.length){var c=
this;c._stopEventLoop();setTimeout(function(){c.options.loop&&(c.eventLoopRerun++,c.options.devMode&&console.log("Before Loop State",c._settings),4<c.eventLoopRerun?(console.error("Maximum amount of loop retries reached."),c._stopEventLoop()):(c.options.devMode&&console.log("Looping events."),c._rerunCalledEvents()))},1E3)}};b._resetEventLoop=function(a){a=a||"Event";this._settings.eventRunning=!1;this._startEventLoop();this.options.devMode&&console.log(a,"Finished")};b._stopEventLoop=function(){window.cancelAnimationFrame(this._eventQueAnimation);
this.options.devMode&&console.log("Event loop stopped.")};b._setupTypwriterWrapper=function(){var a=this.options.wrapperClassName,c=document.createElement("span");c.className=a;this.el.innerHTML="";this.el.appendChild(c)};b._typeCharacters=function(a){this._settings.stringToTypeHTMLArray=this._convertCharsToHTML(a);this._typingAnimation=window.requestAnimationFrame(this._typingAnimationFrame.bind(this,a.length));return this};b._typingAnimationFrame=function(a){var c=this,b=this.options.typingSpeed,
d=c.options.wrapperClassName;if(0==c._settings.stringToTypeHTMLArray.length)return window.cancelAnimationFrame(c._typingAnimation),this._resetEventLoop("typingAnimationFrame"),!0;"natural"==b&&(b=this._randomInteger(50,150));setTimeout(function(){var b=c._settings.stringToTypeHTMLArray[0];c.el.querySelector("."+d).appendChild(b.el);c._settings.currentTypedCharacters.push(b.id);c._settings.stringToTypeHTMLArray.splice(0,1);c._typingAnimation=window.requestAnimationFrame(c._typingAnimationFrame.bind(c,
a));c.options.devMode&&console.log("Typed",b)},b)};b._convertCharsToHTML=function(a){var c=[],b=this.options.charSpanClassName;a=a[0];for(var d=0,e=a.length;d<e;d++){var g=document.createElement("span"),h=this._generateUniqueID();g.id=h;g.className=b+" typewriter-item-"+d;g.innerHTML=a[d];c.push({id:h,el:g})}return c};b._getCharacters=function(a){return"string"!==typeof a?!1:a.split("")};b._getStringsAsCharsArray=function(){var a="string"===typeof this.options.strings;if(!(this.options.strings instanceof
Array))return a?[this.options.strings.split("")]:console.error("Typewriter only accepts strings or an array of strings as the input.");for(var a=[],c=0,b=this.options.strings.length;c<b;c++){var d=this._getCharacters(this.options.strings[c]);if(!d){console.error("Please enter only strings.");break}a.push(d)}return a};b._cursorAnimationFrame=function(){if(!this._settings.cursorAnimationPaused){var a=.001*this.options.blinkSpeed,c=this.el.querySelector(".typewriter-cursor");1==this._settings.opacityIncreasing&&
(1<=this._settings.currentOpacity&&(this._settings.opacityIncreasing=!1,this._settings.currentOpacity=1),this._settings.currentOpacity+=a);0==this._settings.opacityIncreasing&&(0>=this._settings.currentOpacity&&(this._settings.opacityIncreasing=!0,this._settings.currentOpacity=0),this._settings.currentOpacity-=a);c.style.opacity=this._settings.currentOpacity;this._cursorAnimation=window.requestAnimationFrame(this._cursorAnimationFrame.bind(this))}};b._startCursorAnimation=function(){var a=this.options.cursor,
c=this.options.cursorClassName,b=document.createElement("span");b.className=c;b.innerHTML=a;this.el.appendChild(b);this.options.animateCursor&&(this._cursorAnimation=window.requestAnimationFrame(this._cursorAnimationFrame.bind(this)))};b._pauseCursorAnimation=function(){this._settings.cursorAnimationPaused||(window.cancelAnimationFrame(this._cursorAnimation),this._settings.cursorAnimationPaused=!0)};b._restartCursorAnimation=function(){if(!this._settings.cursorAnimationPaused)return console.error("Cursor animation is already running.");
this._settings.cursorAnimationPaused=!1;this._cursorAnimation=window.requestAnimationFrame(this._cursorAnimationFrame.bind(this))};b._randomInteger=function(a,b){return Math.floor(Math.random()*(b-a+1))+a};b._randomID=function(){for(var a="",b=0;b<this._randomInteger(5,15);b++)a+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(62*Math.random()));return a};b._generateUniqueID=function(){var a=this._randomID();return-1==this._settings.usedIDs.indexOf(a)?(this._settings.usedIDs.push(a),
a):this._generateUniqueID.call(this)}})();


// init typewriter page path ***
const typewriterCurrentPath = window.location.pathname;


// welcome ***
if (typewriterCurrentPath === '/') {
    var typeWriteElemOne = document.getElementById("WelcomeTypewriter"); 
    var typewriterOne = new Typewriter(typeWriteElemOne, { loop: true, cursorClassName: "typewritercursor" }); 
    typewriterOne.typeString("BASKETBALL").pauseFor(1000).start();
}

// schedule ***
if (typewriterCurrentPath === '/pages/schedule') {
    var typeWriteElemTwo = document.getElementById("ScheduleTypewriter"); 
    var typewriterTwo = new Typewriter(typeWriteElemTwo, { loop: true, cursorClassName: "typewritercursor" }); 
    typewriterTwo.typeString("SCHEDULE").pauseFor(1000).start();
}

// about ***
if (typewriterCurrentPath === '/pages/about') {
    var typeWriteElemThree = document.getElementById("AboutTypewriter"); 
    var typewriterThree = new Typewriter(typeWriteElemThree, { loop: true, cursorClassName: "typewritercursor" }); 
    typewriterThree.typeString("FLY HIGH").pauseFor(1000).start();
}

// about ***
if (typewriterCurrentPath === '/pages/camps') {
    var typeWriteElemFour = document.getElementById("CampsTypewriter"); 
    var typewriterFour = new Typewriter(typeWriteElemFour, { loop: true, cursorClassName: "typewritercursor" }); 
    typewriterFour.typeString("CAMPS").pauseFor(1000).start();
}


    









// FEATURED EXPANDED GALLERY *****************************************             


// ---- INIT ----
const featuredVideoElements = [
    "https://cdn.shopify.com/videos/c/o/v/3eab7aa4825f48f58167c3d62805dfcd.mov",
    "https://cdn.shopify.com/videos/c/o/v/c166ad71edd1400d95492a7c6354a86c.mov",
    "https://cdn.shopify.com/videos/c/o/v/38d9f22f0de647a6ab5db0d88137470c.mov",
    "https://cdn.shopify.com/videos/c/o/v/7f838a2f5ae14346a73bf64b73d3bef1.mov"
];    
const featuredImageLinks = [
    "//flyhighball.com/cdn/shop/files/bento_1.webp?v=15337438400034533455",
    "//flyhighball.com/cdn/shop/files/bento_2.webp?v=11434703837963994501",
    "//flyhighball.com/cdn/shop/files/bento_3.webp?v=15423323991808953503",
    "//flyhighball.com/cdn/shop/files/bento_4.webp?v=8793822869800117027",
    "//flyhighball.com/cdn/shop/files/bento_5.webp?v=16539732134006051863",
    "//flyhighball.com/cdn/shop/files/bento_6.webp?v=1493644609397218180",
    "//flyhighball.com/cdn/shop/files/bento_7.webp?v=11879249768962005004",
    "//flyhighball.com/cdn/shop/files/bento_8.webp?v=9746198784161685663",
    "//flyhighball.com/cdn/shop/files/bento_9.webp?v=9184891152527662285",
    "//flyhighball.com/cdn/shop/files/bento_10.webp?v=6601897637500619448",
    "//flyhighball.com/cdn/shop/files/bento_11.webp?v=2504131439046671403",
    "//flyhighball.com/cdn/shop/files/bento_12.webp?v=1710751532707750421",
    "//flyhighball.com/cdn/shop/files/bento_13.webp?v=8313898570804158458",
    "//flyhighball.com/cdn/shop/files/bento_1.webp?v=15337438400034533455",
    "//flyhighball.com/cdn/shop/files/bento_2.webp?v=11434703837963994501",
    "//flyhighball.com/cdn/shop/files/bento_3.webp?v=15423323991808953503"
]; 
let fegType = null;   
let fegIndex = 0;  
let fegData = [];


// ---- OPEN ----
function openFEG(type, index) {
  fegType = type;
  fegIndex = index;
  fegData = type === 'video' ? featuredVideoElements : featuredImageLinks;
  $('#FEG-title').text(type === 'video' ? 'FEATURED VIDEOS' : 'FEATURED IMAGES');
  $('#FeaturedExpandedGallery').css({"display":"block"});
  setTimeout(function() { $('#FeaturedExpandedGallery').addClass("display"); }, 50);
  loadFEGItem(index, false);
}


// ---- LOAD ITEM ----
function loadFEGItem(index, animate = true) {
    const $wrap = $('#FEG-content');
    const doLoad = () => {
        $wrap.empty();
        if (fegType === 'video') {
            const $vid = $('<video>', {
                src: fegData[index],
                controls: true,
                autoplay: true
            });
            $wrap.append($vid);
        } 
        else {
            const $img = $('<img>', { src: fegData[index] });
            $wrap.append($img);
        }
        $('#FEG-index').text(`${index + 1} / ${fegData.length}`);
        fegIndex = index;
        setTimeout(() => { $wrap.css('opacity', '1'); }, 100); 
    };
    if (animate) {
        $wrap.css('opacity', '0');
        setTimeout(doLoad, 350);
    } 
    else {
        doLoad(); 
    }
}

 
// ---- CLOSE ----
function closeFEG() {
    $('#FeaturedExpandedGallery').removeClass("display");
    setTimeout(function() {   
        $('#FEG-content').empty();  
        $('#FeaturedExpandedGallery').css({"display":"none"}); 
    }, 550);
}


// ---- PREV ----
function fegPrev() {
    fegIndex === 0 ? loadFEGItem(fegData.length - 1) : loadFEGItem(fegIndex - 1);
}


// ---- NEXT ----
function fegNext() {
    fegIndex === fegData.length - 1 ? loadFEGItem(0) : loadFEGItem(fegIndex + 1);
}


// ---- CLICK GUARDS ----
let fegVideoGuard = false;
let fegImageGuard = false;
let fegCloseGuard = false;
let fegNavGuard = false;


// ---- VIDEO TRIGGER ----
$(document).on('click', '.featured-expanded-gallery-el.video-gallery', function () {
    if (fegVideoGuard) return;
    fegVideoGuard = true;
    setTimeout(() => { fegVideoGuard = false; }, 1000);
    const index = parseInt($(this).data('feg-el-index'));
    openFEG('video', index);
});


// ---- IMAGE TRIGGER ----
$(document).on('click', '.featured-expanded-gallery-el.image-gallery', function () {
    if (fegImageGuard) return;
    fegImageGuard = true;
    setTimeout(() => { fegImageGuard = false; }, 1000);
    const index = parseInt($(this).data('feg-el-index'));
    openFEG('image', index);
});


// ---- CLOSE ----
$('#FEG-close').on('click', function() {
    if (fegCloseGuard) return;
    fegCloseGuard = true;
    setTimeout(() => { fegCloseGuard = false; }, 1000);
    closeFEG();
});


// ---- PREV ----
$('#FEG-prev').on('click', function() {
    if (fegNavGuard) return;
    fegNavGuard = true;
    setTimeout(() => { fegNavGuard = false; }, 1000);
    fegPrev();
});


// ---- NEXT ----
$('#FEG-next').on('click', function() {
    if (fegNavGuard) return;
    fegNavGuard = true;
    setTimeout(() => { fegNavGuard = false; }, 1000);
    fegNext();
});










// MAP SECTION ********************************                
     
    
// map ***
var map = new google.maps.Map(document.getElementById("MapSection"), { 
    zoom: 11, 
    scrollwheel: false,     
    center: { lat: 34.1592, lng: -118.5012 },   
    disableDefaultUI: true, 
    styles: [{"elementType":"geometry","stylers":[{"color":"#FFFFFF"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#D0D0D0"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#FFFFFF"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#F4F4F4"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#F7F7F7"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#E4E4E4"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#EEEEEE"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#FAFAFA"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#F0F0F0"}]}]
}); 
 



// marker ***
var marker = new google.maps.Marker({
    position: new google.maps.LatLng(34.1592, -118.5012),
    map: map,
    icon: {
        url: "//flyhighball.com/cdn/shop/files/marker.png?v=7314195807683982741",
        scaledSize: new google.maps.Size(50, 65) 
    }
});

 









   
// ANIMATION ELEMENT ********************************

    
// scroll listener ***
$(window).on("scroll", function() {   
    $(".animation-element-parent, .parallax-element").each(function() {
    

        // init ***
        var elem = $(this), 
            windowTop = $(window).scrollTop(), 
            windowBottom = (windowTop + $(window).height()), 
            elementTop = elem.offset().top, 
            elementBottom = (elementTop + elem.height());   
          
            
        // handle in view animations ***
        if ((elementBottom >= windowTop) && (elementTop <= windowBottom)) {
            
            // ae
            if (elem.hasClass("animation-element-parent") && !elem.hasClass("animation-done")) {
                // general 
                elem.addClass("animation-done");  
                $(".animation-parent" + elem.attr("data-num")).find(".animation-p").each(function(i, obj) {
                    setTimeout(function() { $(obj).addClass("in-view"); }, i * 100);  
                }); 
            } 
            
            // parallax       
            if (elem.hasClass("parallax-element")) { 
                let scrollDistance = windowBottom - elementTop;
                let percent = scrollDistance / ($(window).height() + elem.height()); 
                if (elem.hasClass("welcome-parallax")) { 
                    scrollDistance = windowTop; 
                    percent = scrollDistance / $("#WelcomeSection").height();    
                }  
                let distance = percent * elem.attr("data-distance");
                let opacityShow = percent * 2.5;
                let opacityHide = (1 - (percent / elem.attr("data-opacityRate")));
                if (elem.hasClass("down")) { elem.css({"transform": "translate(0px," + distance + "px)"}); }  
                if (elem.hasClass("up")) { elem.css({"transform": "translate(0px," + (-distance) + "px)"}); } 
                if (elem.hasClass("opacityShow")) { elem.css({"opacity": opacityShow}); }                 
                if (elem.hasClass("opacityHide")) { elem.css({"opacity": opacityHide}); } 
                if ((elem.hasClass("height"))) { elem.css({"height": distance }); }
            }

        }
     

    }); 
}).scroll();











